import styled from 'styled-components';

import { getThemeColor } from '@utils/styled';

import Typography from '@common/components/Typography';

export const TitleWrapper = styled.div`
  display: flex;
  align-items: baseline;
`;

export const Title = styled(Typography)`
  margin-top: 0;
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 2)};
`;

export const ProductsAmount = styled(Typography).attrs({
  customAs: 'p',
  variant: 'h2',
})`
  ${({ theme }) => theme.getFluidSpacing('margin-left', 'equal', 5)}
  color: ${getThemeColor('bluegrey.60')};

  > span {
    font-weight: 400;
    font-size: 0.7em;
  }
`;

export const FirstPageButtonWrapper = styled.div`
  border-top: 1px solid ${getThemeColor('bluegrey.90')};
  padding: 2rem 0;
  text-align: center;
`;

export const FirstPageButton = styled.button.attrs({
  type: 'button',
})`
  box-shadow: ${({ theme }) => theme.shadows[0]};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadiuses.pill}rem;
  padding: 1.1rem 1.5rem;
  background: white;
  font-size: 1.6rem;
  cursor: pointer;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 10rem;
`;

export const NoProductMessageWrapper = styled.div`
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 23)};
`;

export const NoProductTitle = styled(Typography).attrs({
  variant: 'h4',
})`
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 6)};
`;

export const NoProductText = styled(Typography).attrs({
  variant: 'paragraph1',
})`
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 3)};
`;
